
'use strict'

import { dateToString } from "../../utils/Utils";
import Auth from "./Auth";

class Billboards{
    static get FORMAT_DIGITAL () {return 1};
    static get FORMAT_STATIC () {return 2};
    static get FORMAT_OTHER_MEDIA () {return 3};
    static get IMPRESSIONS () {return 1440};

    static get STATIC_MIN_DAYS_RANGE () {return 30};

    static getBillboards(fields = null, filters = null){
        let query = '';
        
        if(fields != null){
            query += `fields=${fields.join(',')}&`;
        }
        
        if(filters != null){
            for(let filter in filters){
                if(Array.isArray(filters[filter])){
                    if(filters[filter].length > 0){
                        query += `${filter}=${filters[filter].join(',')}&`;
                    }
                }else{
                    query += `${filter}=${filters[filter]}&`;//Ej search
                }
            }
        }

        //Remuevo último caracter si es &
        if(query.slice(-1) == '&'){
            query = query.slice(0,-1);
        }

        return fetch(`${BASE_URL}api/billboards?${query}`, {
                    method: 'GET',
                    headers:{
                        'Cache-Control': 'no-cache'
                    }
                })
               .then((response) => {return response.json()})
               .then((response)=>{
                    return new Promise(function(resolve, reject){
                        if(response.error){
                            reject(Error('Ha ocurrido un error'));
                        }else{
                            resolve(response.data);
                        }
                    })    
                });
    }

    static search(fields = null, filters = null, page = 1, pageSize = 12, sort = null, order = null, calcResultsInfo = false, calcPriceLimits = false){
        let query = '';
        
        if(fields != null){
            query += `fields=${fields.join(',')}&`;
        }
        
        if(filters != null){
            for(let filter in filters){
                if(Array.isArray(filters[filter])){
                    if(filters[filter].length > 0){
                        query += `${filter}=${filters[filter].join(',')}&`;
                    }
                }else if(filters[filter] !== false){
                    query += `${filter}=${filters[filter]}&`;//Ej search
                }
            }
        }

        if(sort != null){
            query += `sort=${sort}&`;    
        }

        if(order != null){
            query += `order=${order}&`;    
        }

        if(calcResultsInfo){
            query += 'calcResultsInfo=true&';    
        }

        if(calcPriceLimits){
            query += 'calcPriceLimits=true&';    
        }

        query += `page=${page}&`;

        query += `page_size=${pageSize}`;

        var urlWithOutParameters = window.location.href.split('?')[0];
        var regex = /internal\/proposals/i;        
        if (regex.test(urlWithOutParameters)) {
            query += `&module=proposal`;
        } else {
            query += `&module=sales`;
        }

        return fetch(`${BASE_URL}api/billboards/search?${query}`, {
                    method: 'GET',
                    headers:{
                        'Cache-Control': 'no-cache'
                    }
                })
               .then((response) => {return response.json()})
               .then((response)=>{
                    return new Promise(function(resolve, reject){
                        if(response.error){
                            reject(Error('Ha ocurrido un error'));
                        }else{
                            resolve(response.data);
                        }
                    })    
                });
    }

    static getBillboardById(id, fields = null, dateRange = null, exclusivity = false, brandId = null, brandCategoryId = null, weekdays = null, staticMinDaysBefore = null, packageId = null){
        let query = '';
        
        if(fields != null){
            query += `fields=${fields.join(',')}&`;
        }

        if(dateRange != null){
            query += `date_range=${dateToString(dateRange.from)},${dateToString(dateRange.to)}&`;
        }

        if(weekdays != null && weekdays.length > 0){
            query += `weekdays=${weekdays.join()}&`;
        }

        if(exclusivity){
            query += `exclusivity=true&`;
        }

        if(brandId != null){
            query += `brand_id=${brandId}&`;
        }

        if(brandCategoryId != null){
            query += `brand_category_id=${brandCategoryId}&`;
        }
        
        if(staticMinDaysBefore != null){
            query += `static_min_days_before=${staticMinDaysBefore}&`;
        }

        if(packageId != null){
            query += `package_id=${packageId}&`;
        }

        if(query.slice(-1) == '&'){
            query = query.slice(0,-1);
        }
        
        return fetch(`${BASE_URL}api/billboards/${id}?${query}`,{
                    method: 'GET',
                    headers:{
                        'Cache-Control': 'no-cache'
                    }
                })
               .then((response) => {return response.json()})
               .then((response)=>{
                    return new Promise((resolve, reject)=>{
                        if(response.error){
                            reject(Error('Ha ocurrido un error'));
                        }else{
                            resolve(response.data);
                        }
                    })    
                });
    }

    static getArtworkPreviewURL(id, src, width = null){
        let url = `${BASE_URL}api/billboards/${id}/artwork-preview?src=${encodeURIComponent(src)}`;
        
        if(width){
            url += `&width=${width}`;
        }

        return url;
    }

    static calculateAvailabilityBillboards(params)
    {
        return Auth.makePrivatePost(`${BASE_URL}api/billboards/calculate-availability`, params);
    }

    static calculateStatsBillboards(params)
    {
        return Auth.makePrivatePost(`${BASE_URL}api/billboards/calculate-stats`, params);
    }

    static getArtworkPreviewDownloadURL(id, src, width = null){
        let url = `${BASE_URL}api/billboards/${id}/artwork-preview/download?src=${encodeURIComponent(src)}`;
        
        if(width){
            url += `&width=${width}`;
        }

        return url;
    }

    static getDimensions() {
        return fetch(`${BASE_URL}api/billboards/dimensions`, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache'
            }
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            return new Promise((resolve, reject) => {
                if (response.error) {
                    reject(response.data);
                } else {
                    resolve(response.data);
                }
            });
        });
    }
}

export default Billboards;